module.exports = __webpack_public_path__ + "videos-collection-page-c7a3cd010e60a5a97f6d.png";